import styled from 'styled-components';
import Text from '@text';
import styleUtils from '../../styles/style.utils';
import themedColor from '../../styles/theme/themed-color';
import themedFontSize from '../../styles/theme/themed-font-size';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 ${styleUtils.px(32)};
  // IE 11 hack
  min-height: 600px;

  @supports (display: grid) {
    min-height: 0;
  }
`;

const Icon = styled.img`
  max-height: ${styleUtils.px(50)};
  margin-bottom: ${styleUtils.px(16)};
`;

const Title = styled(Text)`
  &.ucf-paragraph {
    font-weight: 700;
    max-width: ${styleUtils.px(490)};
    color: ${themedColor('TEXT_BLUE')};
    margin-bottom: ${styleUtils.px(8)};
    text-align: center;
    font-size: ${themedFontSize('BODY')};
  }
`;

const StyledText = styled(Text)`
  &.ucf-paragraph {
    font-weight: 400;
    max-width: ${styleUtils.px(490)};
    color: ${themedColor('TEXT_BLUE')};
    text-align: center;
    margin-bottom: 0;
    font-size: ${themedFontSize('BODY')};
  }
`;

const SuccessPageComponents = { Container, Icon, Title, StyledText };

export default SuccessPageComponents;
